<ion-header>
  <ion-toolbar>
    <ion-title
      [innerText]="restaurantTitle"
      class="modal-title px-2"
    ></ion-title>
    <ion-buttons slot="end">
      <ion-button class="ion-text-capitalize btn-design" (click)="onSaveClick()"
        >Save</ion-button
      >
      <ion-button
        class="ion-text-capitalize btn-design"
        (click)="onCloseClick()"
        >Close</ion-button
      >
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content class="ion-padding form-theme">
  <form
    [formGroup]="restaurantForm"
    *ngIf="restaurantForm"
    class="restaurant-form"
  >
    <!-- Restaurant Details -->
    <ion-card class="form-card">
      <ion-card-header class="form-card-header">
        <ion-card-title>Restaurant Details</ion-card-title>
      </ion-card-header>
      <ion-card-content class="form-card-content">
        <ion-grid>
          <ion-row>
            <ion-col size-lg="12" size-md="6" size="12">
              <ion-item class="form-item">
                <ion-label position="stacked"
                  >Name<span class="text-danger">*</span></ion-label
                >
                <ion-input
                  formControlName="restaurantName"
                  placeholder="Restaurant name"
                ></ion-input>
              </ion-item>
            </ion-col>

            <ion-col size-lg="12" size-md="6" size="12">
              <ion-item class="form-item">
                <ion-label position="stacked">Logo URL</ion-label>
                <ion-input
                  formControlName="restaurantLogoUrl"
                  placeholder="Logo URL"
                ></ion-input>
              </ion-item>
            </ion-col>

            <ion-col size="12">
              <ion-item class="form-item">
                <ion-label position="stacked"
                  >Description<span class="text-danger">*</span></ion-label
                >
                <ion-textarea
                  formControlName="restaurantDescription"
                  placeholder="Restaurant description"
                ></ion-textarea>
              </ion-item>
            </ion-col>

            <ion-col size-lg="4" size-md="6" size="12">
              <ion-item class="form-item">
                <ion-label position="stacked">FSSAI</ion-label>
                <ion-input
                  formControlName="fssai"
                  placeholder="FSSAI Code"
                ></ion-input>
              </ion-item>
            </ion-col>

            <ion-col size-lg="4" size-md="6" size="12">
              <ion-item class="form-item">
                <ion-label position="stacked">GST ID</ion-label>
                <ion-input
                  formControlName="gstId"
                  placeholder="GST ID"
                ></ion-input>
              </ion-item>
            </ion-col>

            <ion-col size-lg="4" size-md="6" size="12">
              <ion-item class="form-item">
                <ion-label position="stacked"
                  >Restaurant Code<span class="text-danger">*</span></ion-label
                >
                <ion-input
                  formControlName="restaurantCode"
                  placeholder="Restaurant Code"
                ></ion-input>
              </ion-item>
            </ion-col>
          </ion-row>
        </ion-grid>
      </ion-card-content>
    </ion-card>

    <!-- Branch Details -->
    <ion-card class="form-card">
      <ion-card-header class="form-card-header">
        <ion-card-title>Branch Details</ion-card-title>
      </ion-card-header>

      <ion-card-content class="form-card-content">
        <ion-grid>
          <ion-row>
            <ion-col size-lg="6" size-md="6" size="12">
              <ion-item class="form-item">
                <ion-label position="stacked"
                  >Branch Name<span class="text-danger">*</span></ion-label
                >
                <ion-input
                  type="text"
                  placeholder="Branch name"
                  formControlName="restaurantBranchName"
                ></ion-input>
              </ion-item>
            </ion-col>

            <ion-col size-lg="6" size-md="6" size="12">
              <ion-item class="form-item">
                <ion-label position="stacked">FSSAI Code</ion-label>
                <ion-input
                  type="text"
                  placeholder="Branch FSSAI"
                  formControlName="restaurantBranchFssai"
                ></ion-input>
              </ion-item>
            </ion-col>

            <ion-col size-lg="6" size-md="6" size="12">
              <ion-item class="form-item">
                <ion-label position="stacked">GST ID</ion-label>
                <ion-input
                  type="text"
                  placeholder="Branch GST ID"
                  formControlName="restaurantBranchGstId"
                ></ion-input>
              </ion-item>
            </ion-col>

            <ion-col size-lg="6" size-md="6" size="12">
              <ion-item class="form-item">
                <ion-label position="stacked"
                  >Branch Code<span class="text-danger">*</span></ion-label
                >
                <ion-input
                  type="text"
                  placeholder="Branch Code"
                  formControlName="restaurantBranchCode"
                ></ion-input>
              </ion-item>
            </ion-col>

            <ion-col size-lg="6" size-md="6" size="12">
              <ion-item class="form-item">
                <ion-label position="stacked"
                  >Number Of Tables<span class="text-danger">*</span></ion-label
                >
                <ion-input
                  type="number"
                  placeholder="Number of tables"
                  formControlName="maxNoOfTables"
                ></ion-input>
              </ion-item>
            </ion-col>

            <ion-col size-lg="6" size-md="6" size="12">
              <ion-item class="form-item">
                <ion-label position="stacked"
                  >Number Of Branches<span class="text-danger"
                    >*</span
                  ></ion-label
                >
                <ion-input
                  type="number"
                  placeholder="Number of branches"
                  formControlName="maxNoOfRestaurantBranches"
                ></ion-input>
              </ion-item>
            </ion-col>

            <ion-col size-lg="6" size-md="6" size="12">
              <ion-item class="form-item">
                <ion-label position="stacked"
                  >Contact Email<span class="text-danger">*</span></ion-label
                >
                <ion-input
                  type="text"
                  placeholder="Contact email"
                  formControlName="restaurantBranchEmailId"
                ></ion-input>
              </ion-item>
            </ion-col>

            <ion-col size-lg="6" size-md="6" size="12">
              <ion-item class="form-item">
                <ion-label position="stacked"
                  >Country Code<span class="text-danger">*</span></ion-label
                >
                <ion-select
                  formControlName="restaurantBranchCountryCode"
                  placeholder="Select Country code"
                >
                  <ion-select-option
                    *ngFor="let code of countryCodes"
                    [value]="code"
                    >{{ code }}</ion-select-option
                  >
                </ion-select>
              </ion-item>
            </ion-col>

            <ion-col size-lg="6" size-md="6" size="12">
              <ion-item class="form-item">
                <ion-label position="stacked"
                  >Contact Number<span class="text-danger">*</span></ion-label
                >
                <ion-input
                  type="text"
                  placeholder="Contact number"
                  formControlName="restaurantBranchContactNo"
                ></ion-input>
              </ion-item>
            </ion-col>

            <ion-col size-lg="6" size-md="6" size="12">
              <ion-item class="form-item">
                <ion-label position="stacked"
                  >Branch Address<span class="text-danger">*</span></ion-label
                >
                <ion-input
                  type="text"
                  placeholder="Flat no, house name, street name, pincode"
                  formControlName="restaurantBranchAddress"
                ></ion-input>
              </ion-item>
            </ion-col>

            <ion-col size-lg="6" size-md="6" size="12">
              <ion-item class="form-item">
                <ion-label position="stacked"
                  >Branch City<span class="text-danger">*</span></ion-label
                >
                <ion-input
                  type="text"
                  placeholder="Restaurant city"
                  formControlName="restaurantBranchCity"
                ></ion-input>
              </ion-item>
            </ion-col>

            <ion-col
              size-lg="6"
              size-md="6"
              size="12"
              *ngIf="restaurantForm.get('restaurantCountry').value === 'India'"
            >
              <ion-item class="form-item">
                <ion-label position="stacked"
                  >Branch State<span class="text-danger">*</span></ion-label
                >
                <ion-select
                  formControlName="restaurantBranchState"
                  placeholder="Select State"
                >
                  <ion-select-option
                    *ngFor="let state of indianStates"
                    [value]="state"
                    >{{ state }}</ion-select-option
                  >
                </ion-select>
              </ion-item>
            </ion-col>

            <ion-col
              size-lg="6"
              size-md="6"
              size="12"
              *ngIf="restaurantForm.get('restaurantCountry').value === 'USA'"
            >
              <ion-item class="form-item">
                <ion-label position="stacked"
                  >Branch State<span class="text-danger">*</span></ion-label
                >
                <ion-select
                  formControlName="restaurantBranchState"
                  placeholder="Select State"
                >
                  <ion-select-option
                    *ngFor="let state of usaStates"
                    [value]="state"
                    >{{ state }}</ion-select-option
                  >
                </ion-select>
              </ion-item>
            </ion-col>

            <ion-col size-lg="6" size-md="6" size="12">
              <ion-item class="form-item">
                <ion-label position="stacked"
                  >Branch Country<span class="text-danger">*</span></ion-label
                >
                <ion-select
                  formControlName="restaurantCountry"
                  (ionChange)="onCountryChange($event)"
                  placeholder="Select Country"
                >
                  <ion-select-option
                    *ngFor="let country of countries"
                    [value]="country"
                    >{{ country }}</ion-select-option
                  >
                </ion-select>
              </ion-item>
            </ion-col>

            <ion-col size-lg="12" size-md="6" size="12">
              <ion-item class="form-item">
                <ion-label position="stacked">Website URL</ion-label>
                <ion-input
                  type="text"
                  placeholder="Website URL"
                  formControlName="restaurantBranchWebsite"
                ></ion-input>
              </ion-item>
            </ion-col>
          </ion-row>
        </ion-grid>
      </ion-card-content>
    </ion-card>

    <ion-card class="form-card">
      <ion-card-header class="form-card-header">
        <ion-card-title>Other Details</ion-card-title>
      </ion-card-header>

      <ion-card-content class="form-card-content">
        <ion-grid>
          <ion-row>
            <ion-col size-lg="6" size-md="6" size="12">
              <ion-item class="form-item">
                <ion-label position="stacked"
                  >Time Zone<span class="text-danger">*</span></ion-label
                >
                <ion-select
                  class="custom-ion-select"
                  [(ngModel)]="selectedTimeZone"
                  formControlName="prefTimeZone"
                  placeholder="Select Time zone"
                >
                  <ion-select-option
                    *ngFor="let time of timeZones"
                    [value]="time?.id"
                    >{{ time?.displayName }}</ion-select-option
                  >
                </ion-select>
              </ion-item>
            </ion-col>

            <ion-col size-lg="6" size-md="6" size="12">
              <ion-item class="form-item">
                <ion-label position="stacked"
                  >Currency Code<span class="text-danger">*</span></ion-label
                >
                <ion-select
                  class="custom-ion-select"
                  formControlName="prefCurrencyCode"
                  placeholder="Select Currency code"
                >
                  <ion-select-option
                    *ngFor="let code of currencyCodes"
                    [value]="code"
                    >{{ code }}</ion-select-option
                  >
                </ion-select>
              </ion-item>
            </ion-col>

            <ion-col size-lg="6" size-md="6" size="12">
              <ion-item class="form-item">
                <ion-label position="stacked"
                  >Payment Preference<span class="text-danger"
                    >*</span
                  ></ion-label
                >
                <ion-select
                  class="custom-ion-select"
                  name="payment-preference"
                  formControlName="allowedPaymentPreferences"
                  multiple="true"
                  placeholder="Select Payment preference"
                >
                  <ion-select-option
                    *ngFor="let preference of paymentPreferences"
                    [value]="preference"
                    >{{
                      preference | lowercase | capitalizeReplace
                    }}</ion-select-option
                  >
                </ion-select>
              </ion-item>
            </ion-col>

            <ion-col size-lg="6" size-md="6" size="12">
              <ion-item class="form-item">
                <ion-label position="stacked"
                  >Order Type<span class="text-danger">*</span></ion-label
                >
                <ion-select
                  class="custom-ion-select"
                  name="order-type"
                  formControlName="allowedOrderTypes"
                  multiple="true"
                  placeholder="Select Order types"
                >
                  <ion-select-option
                    *ngFor="let value of orderTypes"
                    [value]="value"
                    >{{
                      value | lowercase | capitalizeReplace
                    }}</ion-select-option
                  >
                </ion-select>
              </ion-item>
            </ion-col>

            <ion-col size-lg="6" size-md="6" size="12">
              <ion-item class="form-item">
                <ion-label position="stacked"
                  >Status<span class="text-danger">*</span></ion-label
                >
                <ion-select
                  class="custom-ion-select"
                  name="restaurant-status"
                  formControlName="restaurantStatus"
                  placeholder="Select Restaurant status"
                >
                  <ion-select-option
                    *ngFor="let value of restaurantStatus"
                    [value]="value"
                    >{{
                      value | lowercase | capitalizeReplace
                    }}</ion-select-option
                  >
                </ion-select>
              </ion-item>
            </ion-col>

            <ion-col size-lg="6" size-md="6" size="12" class="bg-white">
              <ion-label position="stacked" class="sub-text-label">
                Restaurant Subscription<span class="text-danger">*</span>
              </ion-label>
              <ion-item class="form-item" lines="none">
                <ion-radio-group
                  formControlName="restaurantSubscriptionEntityId"
                >
                  <div class="d-flex mt-2">
                    <div class="d-flex align-items-center me-3">
                      <ion-radio
                        value="basicRestaurantSubscriptionEntityId"
                        class="me-2"
                      ></ion-radio>
                      <ion-label>Basic</ion-label>
                    </div>
                    <div class="d-flex align-items-center">
                      <ion-radio
                        value="standardRestaurantSubscriptionEntityId"
                        class="me-2"
                      ></ion-radio>
                      <ion-label>Standard</ion-label>
                    </div>
                  </div>
                </ion-radio-group>
              </ion-item>
            </ion-col>
            
            <ion-col size-lg="12" size-md="6" size="12">
              <ion-item class="form-item">
                <ion-label position="stacked"
                  >Associate Admin User<span class="text-danger"
                    >*</span
                  ></ion-label
                >
                <ion-input
                  type="text"
                  placeholder="AWS User ID"
                  formControlName="restaurantAdminUserId"
                ></ion-input>
              </ion-item>
            </ion-col>

            <ion-col size-lg="12" size-md="6" size="12" class="mb-2">
              <ion-item class="form-item" lines="none">
                <ion-label position="stacked" class="label-title">
                  {{ 'LOCATION' | translate }}
                </ion-label>
            
                <div class="d-flex flex-wrap justify-content-between align-items-center w-100 mt-2">
                  <div *ngIf="restaurantForm.controls.location.value" class="location-values">
                    <span class="me-3">
                      <strong>Latitude:</strong>
                      {{ restaurantForm.controls.location.value.latitude }}
                    </span>
                    <span>
                      <strong>Longitude:</strong>
                      {{ restaurantForm.controls.location.value.longitude }}
                    </span>
                  </div>
            
                  <ion-button
                    fill="outline"
                    size="small"
                    type="button"
                    (click)="showMap(restaurantForm.controls.location)"
                  >
                    Get Location
                  </ion-button>
                </div>
              </ion-item>
            </ion-col>
            
          </ion-row>
        </ion-grid>
      </ion-card-content>
    </ion-card>
  </form>
</ion-content>
